import { __awaiter } from "tslib";
import LoginSignupContainer from '@getaccept/lib-shared-new/src/login-signup/components/LoginSignupContainer.vue';
import { ref, defineComponent, onMounted } from 'vue';
import { MessageType } from '@getaccept/fried-tofu';
import { useLanguageStore } from '../../language/store/language.store';
import { VerifyUserHelper } from '../helpers/verify-user.helper';
import VerifyUserForm from './VerifyUserForm.vue';
export default defineComponent({
    name: 'VerifyUser',
    components: {
        VerifyUserForm,
        LoginSignupContainer,
    },
    props: {
        signupId: { type: String, default: '' },
        signupKey: { type: String, default: '' },
        firstName: { type: String, default: '' },
        lastName: { type: String, default: '' },
        isInvitation: { type: Boolean, default: false },
    },
    setup(props) {
        const loading = ref(false);
        const error = ref(null);
        const languageStore = useLanguageStore();
        const handleLanguageChange = (language) => languageStore.setLanguage(language.key);
        const handleSubmit = (profileInformation) => __awaiter(this, void 0, void 0, function* () {
            try {
                loading.value = true;
                const responseUrl = yield VerifyUserHelper.verifyUser(profileInformation, props.signupId, props.signupKey);
                window.location.href = responseUrl;
            }
            catch (e) {
                error.value = e;
                VerifyUserHelper.trackVerifyUserError(error.value);
            }
            finally {
                loading.value = false;
            }
        });
        onMounted(() => {
            VerifyUserHelper.trackPageLoaded(props.signupId);
        });
        return { languageStore, loading, error, handleLanguageChange, handleSubmit, MessageType };
    },
});
